export default __webpack_public_path__ + "15381614de24a652c3abef19329a2e6f.svg";